import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './About.css';

const About = () => {
    return (
        <div id="about" className="py-5 about-container">
            <Container>
                <div className="text-center py-5">
                    <h1 className="">About Me</h1>
                    <hr className="dash" />
                </div>
                <Row>
                    <Col xs={12} md={4}>
                        <div data-aos="fade-up-right" className="text-center">
                            {/* <img className="my-image" src="https://i.ibb.co/TTdRGgq/154430617-158613409426730-7427306624905219817-n.jpg" alt="" /> */}
                            {/* <img className="my-image" src="https://i.ibb.co/mCppVYN/IMG-20210307-145056-217.jpg" alt="" /> */}
                            {/* <img className="my-image img-fluid" src="https://i.ibb.co/vxN4qSY/IMG-20190326-153014-925.jpg" alt="" /> */}
                            <img className="my-image img-fluid" src="https://i.ibb.co/NYcYX0T/IMG-20190316-190612.jpg" alt="" />
                        </div>
                    </Col>
                    <Col xs={12} md={8}>
                        <div data-aos="fade-up-left" className="">
                            <div className="px-3 py-3">
                                <p>I am an ambitious individual passionate Web Developer. I’m also an innovative thinker working towards developing technological solutions that will be impactful.</p>
                                <p>I stay updated on all the latest trends and developments associated with this industry and I have the knowledge to apply this information where appropriate. I also have the ability to adhere to all standards, rules, and coding standards set forth by management.</p>

                            </div>
                            <div className="ps-3 information">
                                <p><i class="fas fa-calendar-alt"></i> November 10, 1999</p>
                                <p><i class="fas fa-map-marker-alt"></i> Sunamganj, Bangladesh</p>
                                <p><i class="far fa-envelope-open"></i> hayatulislam28@gmail.com</p>
                                <p><i class="fas fa-phone-square"></i> +8801619624498</p>
                            </div>
                        </div>

                    </Col>
                </Row>
            </Container>

        </div>
    );
};

export default About;